import { createFileRoute, useRouter } from '@tanstack/react-router';
import { RoleForm, type RoleFormDto } from '@/components/organisms/settings-roles/RoleForm';
import { useCreateRole } from '@/hooks/settings/useCreateRole';
import { usePermissionCatalog } from '@/hooks/settings/usePermissions';
import { useHasPermission } from '@/hooks/usePermissions';
import { usePurchasingRoleVisibility } from '@/features/purchasing/visibility';

export const Route = createFileRoute('/_dashboard/dashboard/settings/permissions/new')({
  component: NewRoleSettingsRoute,
});

function NewRoleSettingsRoute() {
  const router = useRouter();
  const canCreate = useHasPermission('roles:create');
  const { data: fullCatalog } = usePermissionCatalog();
  // Purchasing and inventory groups only where their flag is on; the role
  // still saves every permission it holds (PLAT-FF-1).
  const visibility = usePurchasingRoleVisibility();
  const catalog = fullCatalog && {
    ...fullCatalog,
    resources: fullCatalog.resources.filter((entry) => visibility.showResource(entry.resource)),
  };
  const createRole = useCreateRole();

  function close() {
    void router.navigate({ to: '/dashboard/settings/permissions' });
  }

  if (!canCreate) {
    close();
    return null;
  }

  function handleSubmit(dto: RoleFormDto) {
    createRole.mutate(dto, { onSuccess: close });
  }

  return (
    <RoleForm
      mode="create"
      catalog={catalog}
      isPending={createRole.isPending}
      onBack={close}
      onSubmit={handleSubmit}
    />
  );
}
